import { clearBrowseViewCache } from './topicBrowseViewCache';
import { clearBrowsePaginationSessions } from './browsePaginationSessionStore';
import { clearHomeRecommendedTopics } from './homeRecommendedTopics';
import { deactivateHomeDiscovery } from './homeDiscoveryHydrator';
import type { PrototypeRuntime } from './prototypeTypes';

let activeScope: string | null = null;

/**
 * Topic lists include per-viewer flags and recommendation ordering. They may
 * survive a view change, but never an identity, session or plan change.
 */
export function syncTopicViewerCacheScope(runtime: PrototypeRuntime, isLoggedIn: boolean): boolean {
	const nextScope = isLoggedIn
		? `member:${runtime.userId}|session:${runtime.sessionHash}|plan:${runtime.currentPlan ?? 'free'}`
		: 'visitor';
	if (activeScope === nextScope) return false;
	// The first explicit scope may follow an already-painted visitor Home.
	// Clear even from null so a successful login cannot retain that visitor rail.
	clearBrowseViewCache();
	clearBrowsePaginationSessions();
	clearHomeRecommendedTopics();
	deactivateHomeDiscovery();
	activeScope = nextScope;
	return true;
}

export function resetTopicViewerCacheScopeForTest(): void {
	activeScope = null;
}
